export const ruTranslations = {
  nav: {
    tools: 'Инструменты',
    qrGenerator: 'QR-код',
    barcodeGenerator: 'Штрихкод',
    barcodeScanner: 'Сканер штрихкодов',
    qrScanner: 'Сканер',
    blog: 'Статьи',
  },
  langSwitcher: {
    aria: 'Язык интерфейса',
  },
  seo: {
    index: {
      title: 'QR и штрихкод инструменты онлайн - qrka.ru',
      description:
        'Бесплатные инструменты qrka.ru: создать QR-код, сгенерировать штрихкод EAN/UPC/Code 128 и считать QR-код или штрихкод с фото и камеры.',
    },
    qrGenerator: {
      title: 'Генератор QR-кодов онлайн - PNG и SVG бесплатно - qrka.ru',
      description:
        'Создайте статический QR-код для URL, текста, Wi-Fi, vCard, email, SMS или телефона. Настройте вид и скачайте PNG или SVG локально в браузере.',
    },
    qrScanner: {
      title: 'Сканер QR-кода онлайн по скриншоту, фото и с камеры - qrka.ru',
      description:
        'Сканируйте QR-код онлайн: вставьте скриншот через Ctrl+V, выберите фото или включите камеру. Всё работает в браузере, ссылки открываются только по вашему клику.',
    },
    barcodeGenerator: {
      title: 'Генератор штрих-кодов онлайн - EAN, UPC, Code 128 - qrka.ru',
      description:
        'Создайте штрих-код EAN-13, EAN-8, UPC-A, Code 128 или Code 39 онлайн. Проверка формата и бесплатное скачивание PNG или SVG.',
    },
    barcodeScanner: {
      title: 'Сканер штрихкодов онлайн по фото и с камеры - qrka.ru',
      description:
        'Распознайте EAN-13, EAN-8, UPC-A или Code 128 с фото и камеры локально в браузере.',
    },
    blog: {
      title: 'Статьи про QR-коды, печать и генерацию - qrka.ru',
      description:
        'Практические статьи про статические QR-коды, генерацию PNG и SVG, контраст, печать, Wi-Fi QR и выбор между статическим и динамическим QR.',
    },
  },
  common: {
    qrTools: 'QR-инструменты',
    allBlogPosts: 'Все статьи',
    updated: 'обновлено',
    faq: 'Частые вопросы',
    processing: {
      local: {
        label: 'Локально',
        title: 'Данные обрабатываются прямо в браузере и не отправляются на сервер',
      },
    },
  },
  home: {
    hero: {
      title: 'QR-коды и штрихкоды онлайн',
      description:
        'Создайте QR-код прямо здесь: бесплатно, без регистрации, данные остаются в браузере.',
      scanAction: 'Сканировать QR-код',
    },
    tools: {
      title: 'Все инструменты',
      generator: {
        title: 'Генератор QR-кодов',
        description:
          'Создайте статический QR-код для URL, текста, Wi-Fi, vCard, email, SMS или телефона.',
        cta: 'Открыть генератор',
      },
      scanner: {
        title: 'Сканер QR-кодов',
        description:
          'Считайте QR-код с фотографии, скриншота или камеры без установки приложения.',
        cta: 'Открыть сканер',
      },
      barcodeScanner: {
        title: 'Сканер штрихкодов',
        description:
          'Распознайте EAN-13, EAN-8, UPC-A или Code 128 с изображения или камеры.',
        cta: 'Распознать штрихкод',
      },
      barcode: {
        title: 'Генератор штрихкодов',
        description:
          'Создайте EAN-13, EAN-8, UPC-A, Code 128 или Code 39 для этикетки, документа или внутреннего учёта.',
        cta: 'Открыть генератор',
      },
    },
  },
  blog: {
    breadcrumb: 'Статьи',
    title: 'Статьи про QR-коды',
    description:
      'Практические разборы: статический или динамический QR, контраст, печать, SVG, Wi-Fi и сценарии без регистрации.',
    empty: 'Пока нет опубликованных статей.',
    languageAria: 'Язык статей',
    postLanguageAria: 'Язык статьи',
    localeName: {
      ru: 'Русский',
      en: 'English',
    },
    notFoundTitle: 'Статья не найдена',
    notFoundDescription: 'Возможно, материал был перенесён или URL указан с ошибкой.',
    relatedTools: 'Связанные инструменты',
    relatedToolDescription: {
      qrGenerator:
        'Создайте статический QR-код для URL, текста, Wi-Fi, vCard, email, SMS или телефона.',
    },
  },
  schema: {
    name: 'Генератор QR-кодов онлайн',
    description:
      'Создавайте статические QR-коды для URL, текста, Wi-Fi, vCard, email, SMS и телефона локально в браузере.',
    howTo: [
      'Выберите тип QR-кода: URL, текст, Wi-Fi, vCard, email, SMS или телефон.',
      'Введите данные и настройте цвета, размер и уровень коррекции ошибок.',
      'Проверьте контраст, сгенерируйте QR-код и скачайте PNG или SVG.',
    ],
    faq: [
      {
        question: 'Это статический или динамический QR-код?',
        answer:
          'Статический. Все данные сразу записываются в QR-код, поэтому адрес нельзя поменять после печати, а аналитики сканов нет.',
      },
      {
        question: 'Файлы или данные отправляются на сервер?',
        answer:
          'Нет. Генерация выполняется в браузере, без загрузки текста, ссылок, Wi-Fi пароля или контактов на сервер.',
      },
      {
        question: 'Можно скачать SVG бесплатно?',
        answer:
          'Да. PNG и SVG доступны без регистрации, водяных знаков и платных ограничений.',
      },
    ],
  },
  scannerSchema: {
    name: 'Сканер QR-кодов по фото, скриншоту и с камеры',
    description:
      'Считывайте QR-коды с фотографии, скриншота или камеры локально в браузере без установки приложения.',
    howTo: [
      'Вставьте скриншот через Ctrl+V, выберите фото с QR-кодом или нажмите «Включить камеру».',
      'Дождитесь локального распознавания QR-кода в браузере.',
      'Проверьте результат, скопируйте текст или откройте ссылку отдельной кнопкой.',
    ],
    faq: [
      {
        question: 'Как считать QR-код со скриншота?',
        answer:
          'Сделайте скриншот, откройте эту страницу и нажмите Ctrl+V или кнопку «Вставить из буфера». На телефоне сохраните скриншот и выберите его как файл.',
      },
      {
        question: 'Фото или видео отправляются на сервер?',
        answer:
          'Нет. Распознавание выполняется локально в браузере. Камера и загруженные изображения не отправляются на сервер qrka.ru.',
      },
      {
        question: 'Почему браузер просит доступ к камере?',
        answer:
          'Доступ нужен только для режима сканирования камерой. Если доступ запретить, можно считать QR-код с изображения или скриншота.',
      },
      {
        question: 'Открывается ли ссылка автоматически?',
        answer:
          'Нет. Сканер показывает адрес назначения и открывает ссылку только после отдельного клика.',
      },
    ],
  },
  barcodeScannerSchema: {
    name: 'Сканер штрихкодов по фото и с камеры',
    description:
      'Распознавайте EAN-13, EAN-8, UPC-A и Code 128 локально в браузере с изображения или камеры.',
    howTo: [
      'Загрузите PNG, JPG или WebP со штрихкодом либо явно включите камеру.',
      'Наведите камеру на линейный код и дождитесь локального распознавания.',
      'Проверьте определённый формат и скопируйте значение.',
    ],
    faq: [
      {
        question: 'Какие форматы поддерживаются?',
        answer: 'Сканер распознаёт EAN-13, EAN-8, UPC-A и Code 128. Другие форматы пока не поддерживаются.',
      },
      {
        question: 'Фото и кадры камеры отправляются на сервер?',
        answer: 'Нет. Модуль распознавания загружается с qrka.ru, а само распознавание выполняется локально в браузере.',
      },
      {
        question: 'Сканер ищет товар и цену?',
        answer: 'Нет. Инструмент показывает только формат и исходное значение штрихкода без обращения к товарным базам.',
      },
    ],
  },
  barcodeSchema: {
    name: 'Генератор штрих-кодов онлайн',
    description:
      'Создавайте штрихкоды EAN-13, EAN-8, UPC-A, Code 128 и Code 39 с экспортом PNG и SVG.',
    howTo: [
      'Выберите формат штрихкода: EAN-13, EAN-8, UPC-A, Code 128 или Code 39.',
      'Введите значение, проверьте ограничения формата и настройте внешний вид.',
      'Проверьте штрихкод и скачайте изображение в PNG или SVG.',
    ],
    faq: [
      {
        question: 'Генератор регистрирует товарный код?',
        answer:
          'Нет. Инструмент создаёт изображение штрихкода, но не выдаёт и не регистрирует официальные коды GS1 или маркетплейсов.',
      },
      {
        question: 'Какие форматы поддерживаются?',
        answer:
          'Доступны EAN-13, EAN-8, UPC-A, Code 128 и Code 39.',
      },
      {
        question: 'Можно скачать SVG бесплатно?',
        answer:
          'Да. PNG и SVG доступны бесплатно, без регистрации, водяных знаков и ожидания.',
      },
    ],
  },
  qr: {
    hero: {
      title: 'QR-код онлайн без регистрации',
      description:
        'Создайте QR-код для ссылки, текста, Wi-Fi, визитки, почты, SMS или телефона. Всё работает в браузере: данные не уходят на сервер, SVG бесплатно.',
    },
    typeSelectorLabel: 'Тип данных QR-кода',
    howToTitle: 'Как создать QR-код',
    data: {
      description:
        'Статический QR-код нельзя изменить после печати, статистики сканирований нет.',
    },
    typeOptions: {
      url: { label: 'Ссылка' },
      text: { label: 'Текст' },
      wifi: { label: 'Wi-Fi' },
      vcard: { label: 'vCard' },
      email: { label: 'Email' },
      sms: { label: 'SMS' },
      phone: { label: 'Телефон' },
    },
    fields: {
      url: 'Ссылка',
      urlPlaceholder: 'https://example.com',
      text: 'Текст',
      textPlaceholder: 'Введите текст для QR-кода',
      wifiSsid: 'Название сети',
      wifiSsidPlaceholder: 'My Wi-Fi',
      wifiPassword: 'Пароль',
      wifiPasswordPlaceholder: 'Для открытой сети можно оставить пустым',
      wifiEncryption: 'Тип сети',
      wifiWpa: 'WPA/WPA2',
      wifiWep: 'WEP',
      wifiOpen: 'Без пароля',
      wifiHidden: 'Скрытая сеть',
      vcardName: 'Имя',
      vcardOrg: 'Организация',
      vcardPhone: 'Телефон',
      vcardEmail: 'Email',
      vcardUrl: 'Сайт',
      emailAddress: 'Email',
      emailSubject: 'Тема',
      emailBody: 'Текст письма',
      smsPhone: 'Номер телефона',
      smsBody: 'Сообщение',
      phone: 'Номер телефона',
      phonePlaceholder: '+79990000000',
    },
    textDensity: {
      counter: (chars: number, bytes: number) => `${chars} симв., ${bytes} байт`,
      hint: 'Для надёжного сканирования держите текст коротким.',
      warning:
        'QR-код станет плотным. Для печати увеличьте размер изображения и проверьте сканирование телефоном.',
      danger:
        'Текст слишком большой для надёжного QR-кода. Сократите его или используйте ссылку на документ.',
    },
    appearance: {
      title: 'Внешний вид',
      description:
        'По умолчанию QR-код контрастный, со свободным полем вокруг.',
      foreground: 'Цвет QR',
      background: 'Фон',
      size: 'Размер',
      correction: 'Коррекция ошибок',
      contrast: 'Контраст',
      contrastOk: 'Подходит для обычной камеры телефона.',
      contrastBad: 'Слишком низкий контраст: QR может не сканироваться.',
      show: 'Настроить',
      hide: 'Скрыть',
    },
    preview: {
      title: 'Ваш QR-код',
      description: 'Проверьте QR-код камерой телефона перед печатью или рассылкой.',
      empty: 'QR-код появится после ввода данных.',
      generating: 'Обновляем QR-код...',
      imageAlt: 'Готовый QR-код',
      ready: 'QR-код готов.',
      stale: 'Данные изменены, обновляем QR-код…',
      invalid: 'QR-код не построен: проверьте данные.',
      downloadPng: 'Скачать PNG',
      downloadSvg: 'Скачать SVG',
      retry: 'Повторить',
    },
    faqTitle: 'Частые вопросы',
    errors: {
      lowContrast: 'Повысьте контраст цветов минимум до 4.5:1.',
      previewUnavailable: 'QR-код пока недоступен.',
      urlRequired: 'Введите ссылку.',
      invalidUrl: 'Введите корректную ссылку с доменом.',
      textRequired: 'Введите текст для QR-кода.',
      wifiSsidRequired: 'Введите название Wi-Fi сети.',
      emptyVcard: 'Добавьте имя, телефон или email для контакта.',
      emailRequired: 'Введите email.',
      smsPhoneRequired: 'Введите номер телефона для SMS.',
      phoneRequired: 'Введите номер телефона.',
      emptyPayload: 'Заполните данные для QR-кода.',
      generationFailed:
        'Не удалось сгенерировать QR-код. Уменьшите объём текста или проверьте данные.',
    },
  },
  barcode: {
    hero: {
      title: 'Генератор штрих-кодов онлайн',
      description:
        'Выберите EAN-13, EAN-8, UPC-A, Code 128 или Code 39, введите значение и скачайте штрихкод. Всё работает в браузере, без регистрации и водяных знаков.',
    },
    formatOptions: {
      ean13: { label: 'EAN-13' },
      ean8: { label: 'EAN-8' },
      upc: { label: 'UPC-A' },
      code128: { label: 'Code 128' },
      code39: { label: 'Code 39' },
    },
    formatHelp: {
      ean13: 'Введите 12 цифр, чтобы контрольная цифра добавилась автоматически, или 13 цифр с корректной контрольной суммой.',
      ean8: 'Введите 7 цифр для автоматической контрольной цифры или полный 8-значный код.',
      upc: 'Введите 11 цифр для автоматической контрольной цифры или полный 12-значный UPC-A.',
      code128: 'Подходит для внутренних кодов, инвентарных номеров и произвольного текста до 80 символов.',
      code39: 'Поддерживает латинские заглавные буквы, цифры, пробел и символы - . $ / + %.',
    },
    fields: {
      value: 'Значение',
      valuePlaceholder: {
        ean13: '460123456789',
        ean8: '1234567',
        upc: '03600029145',
        code128: 'ORDER-2026-001',
        code39: 'ITEM-123',
      },
    },
    appearance: {
      title: 'Внешний вид',
      description:
        'Оставляйте высокий контраст и достаточно свободного поля вокруг кода для надёжного считывания.',
      lineColor: 'Цвет линий',
      background: 'Фон',
      width: 'Толщина линии',
      height: 'Высота',
      displayValue: 'Показывать значение под штрихкодом',
    },
    preview: {
      title: 'Ваш штрихкод',
      description: 'Проверьте код сканером перед печатью партии этикеток.',
      empty: 'Введите значение, чтобы увидеть штрихкод.',
      pendingUpdate: 'Обновление...',
      generate: 'Сгенерировать',
      generating: 'Генерируем...',
      ready: 'Штрихкод готов.',
      invalid: 'Штрихкод не построен: проверьте данные.',
      downloadPng: 'Скачать PNG',
      downloadSvg: 'Скачать SVG',
      normalized: 'Итоговое значение',
      registrationNotice:
        'Важно: инструмент создаёт изображение кода. Он не регистрирует товарный код в GS1, Честном ЗНАКе, маркетплейсах или складских системах.',
    },
    faqTitle: 'Частые вопросы',
    faq: [
      {
        question: 'Можно ли использовать код для товара в магазине?',
        answer:
          'Изображение можно напечатать, но сам номер должен быть выдан или разрешён вашей системой учёта, GS1 или площадкой, где товар продаётся.',
      },
      {
        question: 'Почему EAN/UPC не принимает любой набор цифр?',
        answer:
          'У этих форматов фиксированная длина и контрольная цифра. Если введён полный код, генератор проверяет контрольную сумму.',
      },
      {
        question: 'Чем Code 128 отличается от Code 39?',
        answer:
          'Code 128 компактнее и поддерживает больше символов. Code 39 проще, но обычно длиннее и ограничен заглавной латиницей, цифрами и несколькими символами.',
      },
    ],
    errors: {
      emptyValue: 'Введите значение для штрихкода.',
      previewUnavailable: 'Штрихкод пока недоступен.',
      ean13: 'EAN-13 должен содержать 12 цифр или 13 цифр с корректной контрольной суммой.',
      ean8: 'EAN-8 должен содержать 7 цифр или 8 цифр с корректной контрольной суммой.',
      upc: 'UPC-A должен содержать 11 цифр или 12 цифр с корректной контрольной суммой.',
      code128: 'Code 128 должен быть непустым и не длиннее 80 символов.',
      code39: 'Code 39 поддерживает только A-Z, цифры, пробел и символы - . $ / + %, до 80 символов.',
      generationFailed: 'Не удалось сгенерировать штрихкод. Проверьте формат и значение.',
      pngExportFailed: 'Не удалось подготовить PNG. Попробуйте скачать SVG.',
      svgExportFailed: 'Не удалось подготовить SVG. Попробуйте ещё раз.',
    },
  },
  scanner: {
    hero: {
      title: 'Сканер QR-кода онлайн: скриншот, фото, камера',
      description:
        'Вставьте скриншот, выберите фото или включите камеру. Распознавание идёт в браузере, ссылки не открываются сами.',
    },
    upload: {
      dropDescription: 'PNG, JPG или WebP, до 20 МБ. Файл обрабатывается локально.',
      choose: 'Выбрать фото или скриншот',
      paste: 'Вставить из буфера',
      pasteHint: 'Или нажмите Ctrl+V на этой странице.',
      reading: 'Считываем...',
    },
    camera: {
      placeholder: 'Камера появится здесь после разрешения доступа.',
      permissionHint: 'Разрешение будет запрошено только после нажатия. Загрузка файла останется доступна при отказе.',
      previewTitle: 'Камера включена',
      start: 'Включить камеру',
      starting: 'Запрашиваем доступ...',
      stop: 'Остановить',
    },
    result: {
      title: 'Результат',
      description: 'Проверьте содержимое перед копированием или открытием ссылки.',
      empty: 'Вставьте скриншот, выберите фото или включите камеру, чтобы считать QR-код.',
      sourceUpload: 'Источник: изображение',
      sourceCamera: 'Источник: камера',
      destination: 'Адрес назначения',
      openLink: 'Открыть ссылку',
      copy: 'Скопировать',
      copied: 'Скопировано',
    },
    howToTitle: 'Как считать QR-код',
    faqTitle: 'Частые вопросы',
    errors: {
      no_qr_found: 'QR-код не найден. Попробуйте более чёткое изображение без бликов.',
      multiple_codes: 'На изображении найдено несколько QR-кодов. Обрежьте его и оставьте один код.',
      unsupported_file: 'Не удалось прочитать файл. Загрузите корректное изображение PNG, JPG или WebP.',
      file_too_large: 'Изображение слишком большое. Лимиты: 20 МБ, 12 000 px на сторону и 40 Мп.',
      scanner_failed: 'Не удалось запустить распознавание. Обновите страницу и попробуйте снова.',
      permission_denied: 'Доступ к камере запрещён. Разрешите камеру в браузере или загрузите изображение.',
      unsupported_browser: 'Этот браузер не поддерживает сканирование камерой. Загрузите изображение с QR-кодом.',
      camera_failed: 'Не удалось запустить камеру. Проверьте доступ и попробуйте ещё раз.',
      camera_timeout: 'QR-код не найден за 30 секунд. Попробуйте снова или загрузите фото или скриншот.',
      clipboard_empty: 'В буфере нет картинки. Скопируйте скриншот и попробуйте снова.',
      clipboard_unavailable: 'Браузер не дал прочитать буфер. Нажмите Ctrl+V на странице или выберите файл.',
    },
  },
  barcodeScanner: {
    hero: {
      title: 'Сканер штрихкодов онлайн по фото и с камеры',
      description:
        'Распознайте EAN-13, EAN-8, UPC-A или Code 128 локально в браузере. Камера включается только после вашего клика.',
    },
    upload: {
      dropDescription: 'PNG, JPG или WebP, до 20 МБ. Файл не отправляется на сервер.',
      choose: 'Выбрать фото',
      paste: 'Вставить из буфера',
      pasteHint: 'Или нажмите Ctrl+V на этой странице.',
      reading: 'Распознаём...',
    },
    camera: {
      placeholder: 'Наведите камеру на штрихкод так, чтобы линии были в фокусе.',
      permissionHint: 'Разрешение будет запрошено только после нажатия. Загрузка файла останется доступна при отказе.',
      previewTitle: 'Камера включена',
      start: 'Включить камеру',
      starting: 'Запрашиваем доступ...',
      stop: 'Остановить',
    },
    result: {
      title: 'Результат',
      description: 'Сканер показывает определённый формат и исходное значение.',
      empty: 'Загрузите изображение или включите камеру, чтобы распознать штрихкод.',
      sourceUpload: 'Источник: изображение',
      sourceCamera: 'Источник: камера',
      destination: 'Адрес назначения',
      openLink: 'Открыть ссылку',
      copy: 'Скопировать значение',
      copied: 'Скопировано',
    },
    howToTitle: 'Как распознать штрихкод',
    faqTitle: 'Частые вопросы',
    relatedQrScanner: 'Открыть сканер QR-кодов',
    errors: {
      no_qr_found: 'Поддерживаемый штрихкод не найден. Попробуйте более чёткое фото без бликов.',
      multiple_codes: 'Найдено несколько штрихкодов. Проверьте каждый результат.',
      unsupported_file: 'Не удалось прочитать файл. Загрузите корректное изображение PNG, JPG или WebP.',
      file_too_large: 'Изображение слишком большое. Лимиты: 20 МБ, 12 000 px на сторону и 40 Мп.',
      scanner_failed: 'Не удалось запустить распознавание. Обновите страницу и попробуйте снова.',
      permission_denied: 'Доступ к камере запрещён. Разрешите камеру или загрузите изображение.',
      unsupported_browser: 'Этот браузер не поддерживает камеру. Загрузите изображение со штрихкодом.',
      camera_failed: 'Не удалось запустить камеру. Проверьте доступ и попробуйте ещё раз.',
      camera_timeout: 'Штрихкод не найден за 30 секунд. Попробуйте снова или загрузите фото.',
      clipboard_empty: 'В буфере нет картинки. Скопируйте изображение и попробуйте снова.',
      clipboard_unavailable: 'Браузер не дал прочитать буфер. Нажмите Ctrl+V на странице или выберите файл.',
    },
  },
}

export type Translations = typeof ruTranslations
